import { channel } from 'redux-saga'

export const toastDispatchableActionsChannel = channel()
